import { ComponentSync } from '@nu-art/thunderstorm-frontend/index';
export class DropDown_AtomLeftHand extends ComponentSync {
}
//# sourceMappingURL=ui-components.js.map